import InsideSalesSelectors from './InsideSalesSelectors';

export default InsideSalesSelectors;
